<template>
  <div class="q-mt-lg">
    <div class="row col-12 q-mt-md q-ml-md">
      <div
        style="font-size: 16px"
        class="q-mb-sm text-brand-1 text-weight-medium"
      >
        <span
          >Selecione as Unidades que deseja visualizar o Estoque Atual.</span
        >
      </div>
      <div class="row col-12 q-gutter-sm">
        <div class="col-4">
          <div class="text-brand-1 text-weight-bold q-ml-sm">Unidade</div>
          <UnidadeSelect v-model="vendors" :multiple="true" />
        </div>
      </div>
    </div>
    <div class="q-mt-lg q-mb-sm q-ml-md">
      <div
        style="font-size: 16px"
        class="q-mb-sm text-brand-1 text-weight-medium"
      >
        <span>Selecione os produtos que deseja incluir no pedido.</span>
      </div>
      <section class="row q-gutter-sm">
        <div class="col-md-3 col-2">
          <q-select
            :options="filtros"
            label="Posição Estoque"
            dense
            outlined
            v-model="estoque"
          />
        </div>
        <div class="col-md-3 col-2">
          <q-select
            :options="filtros2"
            label="Itens p/ Página"
            dense
            outlined
            v-model="per_page"
          />
        </div>
        <div class="col-md-3 col-2">
          <q-select
            :options="filtros3"
            label="Fornecedor"
            dense
            outlined
            v-model="fornecedor"
          />
        </div>
      </section>
    </div>

    <q-table
      flat
      :rows="rows"
      dense
      :columns="columns"
      :loading="disable"
      :filter="filtrar"
      table-header-style="background-color: #d9effc"
      class="tabela-tamanho-fixo"
      hide-pagination
      v-model:pagination="pagination"
      :rows-per-page-options="[0]"
      @request="handleRequest"
    >
      <template #body-cell-comentario="props">
        <q-td>
          <q-input
            dense
            v-model="props.row.comentario"
            outlined
            label="Comentario"
          />
        </q-td>
      </template>

      <template #body-cell-adicionar="props">
        <q-td>
          <div class="row">
            <q-btn
              @click="adicionar(props.row.product_id, props.row)"
              round
              flat
              color="positive"
              icon="sym_o_add_circle"
            />
          </div>
        </q-td>
      </template>
    </q-table>
    <div class="row justify-start q-mt-md">
      <q-pagination
        :disable="disable"
        v-model="pagination.page"
        color="brand-5"
        active-color="secondary"
        active-text-color="white"
        :max="pagesNumber"
        :max-pages="5"
        :boundary-numbers="false"
        :direction-links="true"
        size="sm"
      />
    </div>

    <produtos-selecionados
      :atualizar="atualizar"
      :selecionados="produtos"
      @atualizar="getPrincipal"
    />
  </div>
</template>

<script>
const columns = [
  {
    name: "adicionar",
    label: "Adicionar",
    field: "adicionar",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },

  {
    name: "product_code",
    label: "Código",
    field: "product_code",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "product_name",
    label: "Produto",
    field: "product_name",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },

  {
    name: "nome_fornecedor",
    label: "Ultimo Forn.",
    field: "nome_fornecedor",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },

  {
    name: "lead_time",
    label: "Lead Time	",
    field: "lead_time",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "product_category_code",
    label: "Categoria",
    field: "product_category_code",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "ultima",
    label: "R$ Ultima Compra",
    field: "ultima",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "amount",
    label: "Estoque Atual",
    field: "amount",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "replacement_amount",
    label: "Ponto de Reposição",
    field: "replacement_amount",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "minimal_amount",
    label: "Estoque Crítico	",
    field: "minimal_amount",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "max_amount",
    label: "Estoque Máximo	",
    field: "max_amount",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "aberto",
    label: "Quantidade em Aberto	",
    field: "aberto",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "open_puchase",
    label: "Compra em Aberto",
    field: "open_puchase",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "sugerida",
    label: "Compra Sugerida",
    field: (row) => (row.sugerida = 0),
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
];

import { ref, onMounted, watch, computed } from "vue";
import { useStore } from "vuex";
//import { useRoute } from "vue-router";
import { useQuasar } from "quasar";
import ProdutosSelecionados from "./ProdutosSelecionados.vue";
import UnidadeSelect from "../../../../components/unidade/UnidadeSelect.vue";
export default {
  components: { UnidadeSelect, ProdutosSelecionados },
  props: ["provider_id"],
  setup(props, { emit }) {
    const store = useStore();
    const $q = useQuasar();
    const rows = ref([]);
    const disable = ref(true);
    const estoque = ref("");
    const per_page = ref("25");
    const atualizar = ref(0);
    //const route = useRoute();
    const fornecedor = ref("TODOS");
    const vendors = ref([]);
    const produtos = ref([]);
    //const id = route.params.id;

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 25,
      // rowsNumber: 15,
    });

    const getDados = async () => {
      try {
        const response = await store.dispatch("compras/getProducts", {
          per_page: per_page.value,
          provider_id: fornecedor.value.value == 0 ? "" : props.provider_id,
          stock: estoque.value.value,
        });

        rows.value = response.data.results.data;

        disable.value = false;
      } catch (error) {
        console.log(error);
        $q.notify({
          message: "Erro a o encontrar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getDados);

    const adicionar = async (product_id, produto) => {
      if (vendors.value.length === 0) {
        $q.notify({
          message: "Selecione as Unidades.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      let unidadeIds = vendors?.value.map((unidade) => unidade.id);
      try {
        const response = await store.dispatch("compras/adicionarProduto", {
          product_id: product_id,
          vendors: unidadeIds.toString(),
        });

        $q.notify({
          message: "Produto adicionado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        produtos.value.push({
          ...produto,
          quinzed: response.data.data.quinze_dias[0].total,
          trintad: response.data.data.trinta_dias[0].total,
          tres_meses: response.data.data.tres_meses[0].total,
        });

        atualizar.value++;
      } catch (error) {
        $q.notify({
          message: "Erro a o adicionar produto, Selecione as Unidades",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const handleRequest = async () => {
      getDados(pagination.value.page, pagination.value.rowsPerPage);
    };

    const getPrincipal = async () => {
      setTimeout(() => {
        emit("atualizar");
      }, 1000);
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => fornecedor.value,
      () => {
        getDados();
      }
    );

    watch(
      () => estoque.value,
      () => {
        getDados();
      }
    );

    watch(
      () => per_page.value,
      () => {
        getDados();
      }
    );

    return {
      pagination,
      rows,
      disable,
      columns,
      getDados,
      handleRequest,
      getPrincipal,
      pagesNumber: computed(() =>
        Math.ceil(rows.value.length / pagination.value.rowsPerPage)
      ),
      filtros: [
        {
          label: "TODOS",
          value: "",
        },
        {
          label: "Ab. Reposição",
          value: "open_purchase",
        },
        {
          label: "Ab. Critico",
          value: "lower_crit",
        },
      ],
      filtros2: ["5", "25", "50", "100", "500"],
      filtros3: [
        {
          label: "TODOS",
          value: 0,
        },
        {
          label: "SOMENTE DO PEDIDO",
          value: 1,
        },
      ],

      estoque,
      per_page,
      fornecedor,
      adicionar,
      vendors,
      atualizar,
      produtos,
    };
  },
};
</script>

<style>
.align {
  align-items: center;
}
tbody tr td {
  white-space: pre-wrap;
}
</style>
